import { useAppSelector } from "@/lib/hooks"

const FavIcon = () => {
  const ciabName = useAppSelector((s) => s.configuration?.ciabName)
  return <link rel="icon" href={`/favicons/${ciabName}.ico`} sizes="any" />
}

export default FavIcon
